// カードを新規追加するモーダルのコンポーネント

import React from 'react';

import {QRCodeCanvas} from 'qrcode.react';

import './CouponModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";


const QRCode = ( {coupon_code} ) => {
    return (
        <div style={{ height: "auto", margin: "0 auto", maxWidth: 256, width: "100%" }}>
          <QRCodeCanvas value={coupon_code} 
          style={{ height: "auto", maxWidth: "100%", width: "100%" }}/>
        </div>
    );
};


const CouponModal = ({isOpen, onRequestClose, couponInfo}) => {
    const { t } = useTranslation();
    
    const closeModal = () => {
        onRequestClose();
    }
    
    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                className="shop-payment-coupon-modal"
                overlayClassName="shop-payment-coupon-modal-overlay"
                contentLabel="Example Modal"
            >
                <div className="dialog-contents">
                    <div className="shop-payment-coupon-modal-title">{t('coupon_modal.title')}</div>
                    <div className="shop-payment-coupon-modal-item">
                        {t('coupon_modal.coupon')}：{couponInfo.code}
                    </div>
                    <div className="shop-payment-coupon-modal-item">
                        URL：{couponInfo.url}
                    </div>
                    <div className="shop-payment-coupon-modal-item">
                        <QRCode coupon_code={couponInfo.url}/>
                    </div>

                    <div className="shop-payment-coupon-modal-button">
                        <button className="shop-payment-coupon-modal-button-cancel" onClick={()=>{onRequestClose()}}>CLOSE</button>
                    </div>
                </div>

            </Modal>
        </>
    );
}

export default CouponModal;




